import { Typography } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import { PartnerPortalUpdateNotification } from "apps/oneOnboarding/pricing/PartnerPortalUpdateNotification";
import { useStaticDataAtomValue } from "apps/oneOnboarding/staticDataAtom";
import type { FunctionComponent } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import type { BulkPropertyFormData } from "../BulkPropertyFormData";
import { PropertyPricingDetail } from "./PropertyPricingDetail";

interface Props {
    hideHeader?: boolean;
}

export const PropertyPricingList: FunctionComponent<Props> = ({ hideHeader }) => {
    const { control } = useFormContext<BulkPropertyFormData>();
    const {
        cmsData: {
            pricing: { setYourRate },
        },
    } = useStaticDataAtomValue();

    const { fields } = useFieldArray({
        control,
        name: "propertyDataList",
    });

    return (
        <VStack gap="16" data-testid="property-pricing-list">
            {!hideHeader && <Typography variant="heading-default">{setYourRate}</Typography>}
            <PartnerPortalUpdateNotification snha />
            {fields.map((field, i) => (
                <PropertyPricingDetail
                    data-testid={`property-pricing-detail-${i}`}
                    key={field.id}
                    fieldPrefix={`propertyDataList.${i}`}
                    propertyKey={field.onboardingId ?? `${field.propertyId}`}
                    name={field.propertyName}
                    image={field.photos?.[0]?.src}
                    countryId={field.country.id}
                    cityName={field.city.name}
                />
            ))}
        </VStack>
    );
};
